import getEnv, { PROD } from './getEnv';

/**
 * On nonprod always returns true and if on live returns true 10% of the time.
 *
 * @returns {boolean} true 10% of the time on prod and 100% of the time on NP
 * @example
 */
const eventShouldBeTracked = () =>
	getEnv() !== PROD || Math.floor(Math.random() * (100 - 0) + 1) <= 10;

export default eventShouldBeTracked;
